var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemindersWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2765_297)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2765_297",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2765_297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8198 34.8354C41.3287 33.5742 40.1308 32.0026 39.3098 30.2306C38.4888 28.4585 38.0645 26.5285 38.0665 24.5755V18.994C38.0665 11.9491 32.8439 6.11748 26.0788 5.14053V2.97842C26.0788 2.44853 25.8683 1.94034 25.4936 1.56565C25.1189 1.19097 24.6108 0.980469 24.0809 0.980469C23.551 0.980469 23.0428 1.19097 22.6681 1.56565C22.2934 1.94034 22.0829 2.44853 22.0829 2.97842V5.14053C15.3159 6.11709 10.0952 11.9491 10.0952 18.994V24.5755C10.0964 26.5324 9.67006 28.466 8.846 30.241C8.02194 32.0159 6.82006 33.5895 5.32443 34.8515C4.78154 35.3171 4.39413 35.9377 4.21423 36.6299C4.03433 37.3221 4.07055 38.0528 4.31803 38.7239C4.56551 39.3949 5.0124 39.9741 5.59868 40.3838C6.18496 40.7935 6.88255 41.0139 7.59777 41.0155H40.5641C41.2814 41.0139 41.9809 40.7922 42.5682 40.3804C43.1555 39.9685 43.6023 39.3864 43.8483 38.7126C44.0942 38.0388 44.1275 37.3057 43.9436 36.6124C43.7597 35.919 43.3675 35.2988 42.8199 34.8354H42.8198Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0826 49.0215C25.8104 49.0179 27.484 48.4184 28.8212 47.3244C30.1584 46.2303 31.0774 44.7085 31.423 43.0156H16.7422C17.0879 44.7085 18.0068 46.2303 19.344 47.3244C20.6812 48.4184 22.3549 49.0179 24.0826 49.0215Z",
    fill: "#DADADA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2765_297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemindersWhite);
export default __webpack_public_path__ + "static/media/reminders_white.6219302a643fac925614f88eefcc0a3c.svg";
export { ForwardRef as ReactComponent };